import Vue from "vue";
import { addSamples, getItems, getNonSampleItems, isProductInSamplesArray } from "../product-samples/product-samples";
import { Constants } from "../product-samples/samples-constants";
import { getSampleProducts } from "../product-samples";
import { getMetafieldValue } from "../product-showcase/product-showcase";
import { showCartSideDraw } from "../../sections/cart-drawer";

export default () => {
  if (!document.getElementById("product-finder-root-vue-events")) {
    return false;
  }

  new Vue({
    el: "#product-finder-root-vue-events",
    methods: {
      async onSampleAdded(event) {
        const customer = event.detail.customer;
        const mains = event.detail.samples;
        const linkedSamples = mains.map((main) => getMetafieldValue(main.metafields, 'linked_sample')).filter(Boolean);
        const samples = await getSampleProducts(linkedSamples);
        const addedSamples = samples.map((sample) => {
          const metafields = sample.metafields;
          const isKit = getMetafieldValue(metafields, 'is_sample_kit') === 'true';
          const weight = Number(getMetafieldValue(metafields, 'sample_kit_weight') || (isKit ? 3 : 1));
          const id = sample.variants.edges[0].node.id.replace('gid://shopify/ProductVariant/', '');
          return { variant_id: id, handle: sample.handle, isKit, weight, isSample: true };
        });

        // const handles = addedSamples.map((sample) => sample.handle);
        let samplesToAdd = addedSamples.filter((sample) => !isProductInSamplesArray(sample.variant_id));
        // const samplesToRemove = getItems().filter((sample) => !handles.includes(sample.handle));

        // clear cart if there are samples to remove
        // if (samplesToRemove.length) {
        //   samplesToAdd = [];
        //   samplesToAdd.push(...getNonSampleItems(), ...addedSamples);
        //   await CartJS.clear();
        // }
        // If there are no samples to add, redirect to the cart
        // if (samplesToAdd.length === 0) {
        // window.location.href = '/cart';
        // // return;
        // // }
        if (samplesToAdd.length) {
          await addSamples(samplesToAdd, Constants.locations.ProductFinder, customer);
        }

        window.location.href = '/cart';
      },
    },
    beforeMount() {
      document.addEventListener(Constants.events.SAMPLE_ADDED_PFv2, this.onSampleAdded);
    },
  });
};

